import { Opaque } from '@utils/opaque';

type Like2BuyV2StoreId = Opaque<string, 'Like2BuyV2StoreId'>;

function Like2BuyV2StoreIdFactory(like2BuyV2StoreId: string) {
  return like2BuyV2StoreId as Like2BuyV2StoreId;
}

const Like2BuyV2StoreId = Like2BuyV2StoreIdFactory;

export default Like2BuyV2StoreId;
